/**
 * Enum for different sources of meteorology
 */
const MetSourceTypeEnum = {
    SCENARIO_PRESETS: 'SCENARIO_PRESETS',
    MET_SERVICE: 'MET_SERVICE',
    SIMULATION: 'SIMULATION',
};

export default MetSourceTypeEnum;